import { toast } from 'react-toastify';

/**
 * Success toast for a just-created entity — clicking it navigates to the entity's own detail
 * page. `path` is optional: pass a falsy value (e.g. a bulk-creation response with no single
 * target) to fall back to a plain, non-clickable success toast.
 */
export function toastCreated(navigate, message, path, hint = 'Cliquer pour voir') {
  if (!path) {
    toast.success(message);
    return;
  }

  toast.success(
    <div>
      <div>{message}</div>
      <div style={{ fontSize: 12, opacity: 0.8, marginTop: 2 }}>{hint}</div>
    </div>,
    { onClick: () => navigate(path), style: { cursor: 'pointer' } }
  );
}
